import { render, staticRenderFns } from "./paymentFailed.vue?vue&type=template&id=95247b32&scoped=true&"
import script from "./paymentFailed.vue?vue&type=script&lang=ts&"
export * from "./paymentFailed.vue?vue&type=script&lang=ts&"
import style0 from "./paymentFailed.vue?vue&type=style&index=0&id=95247b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95247b32",
  null
  
)

export default component.exports